// API Models

export interface ApiMedicationItemResponse {
  ndc: string;
  name: string;
}

export interface ApiMedicalHistoryResponse {
  medications: ApiMedicationItemResponse[];
  medicalConditions: string[];
  allergyConditions: string[];
}

export interface ApiHealthConditionsResponse {
  medicalConditions: string[];
  allergyConditions: string[];
}

export interface ApiMedicationsSearchItemResponse {
  label: string;
  value: string;
}

export interface ApiMedicalHistoryRequest {
  medicationNdcs: string[];
  medicalConditions: string[];
  allergyConditions: string[];
}

// Front End Models

export interface Medication extends ApiMedicationItemResponse {}

export interface PatientMedicalHistory {
  medications: Medication[];
  medicalConditions: string[];
  allergyConditions: string[];
}

export interface HealthConditions {
  medicalConditions: string[];
  allergyConditions: string[];
  noneAllergyCondition?: string;
}

// Form Models

export interface PatientMedicalHistoryFormValues {
  medications: { label: string; value: string }[];
  medicalConditions: string[];
  allergies: string[];
}

export const mapPatientMedicalHistory = (apiMedicalHistory: ApiMedicalHistoryResponse): PatientMedicalHistory => {
  return {
    medications: apiMedicalHistory.medications,
    medicalConditions: apiMedicalHistory.medicalConditions,
    allergyConditions: apiMedicalHistory.allergyConditions.filter((ac) => ac.toLowerCase() !== 'none'),
  };
};

export const mapHealthConditions = (apiHealthConditions: ApiHealthConditionsResponse): HealthConditions => {
  return {
    medicalConditions: apiHealthConditions.medicalConditions,
    allergyConditions: apiHealthConditions.allergyConditions.filter((ac) => ac.toLowerCase() !== 'none'),
    noneAllergyCondition: apiHealthConditions.allergyConditions.find((ac) => ac.toLowerCase() === 'none'),
  };
};

export const buildUpdateMedicalHistoryRequest = (
  formValues: PatientMedicalHistoryFormValues
): ApiMedicalHistoryRequest => {
  // TODO: submit only ndcs/ids after updating the API
  return {
    medicationNdcs: formValues.medications.map((m) => m.value),
    medicalConditions: formValues.medicalConditions,
    allergyConditions: formValues.allergies?.length ? formValues.allergies : ['None'],
  };
};
